export default "__VITE_ASSET__86f79f97__$_?component__"